export const SHOW_JSON_COMPARE_MODAL = "SHOW_JSON_COMPARE_MODAL";
export const SHOW_JSON_COMPARE_MODAL_HIDE = "SHOW_JSON_COMPARE_MODAL_HIDE";